import React from 'react';

interface IconDarkmodeProps {
  styles?: React.SVGProps<SVGSVGElement>;
  className?: string;
}

const IconDarkmode = ({ styles, className }: IconDarkmodeProps) => {
  return (
    <svg
      id="Layer_1"
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 24 24`}
      {...styles}
      className={className}
    >
      <g fill="currentColor">
        <path d="M12,18.92c-.29,0-.55.11-.76.32-.21.21-.32.46-.32.76v2c0,.29.11.55.32.76.21.21.46.32.76.32s.55-.11.76-.32c.21-.21.32-.46.32-.76v-2c0-.29-.11-.55-.32-.76-.21-.21-.46-.32-.76-.32Z" />
        <path d="M5.59,7.1c.22.21.48.31.77.32.29,0,.54-.1.74-.32.21-.22.31-.47.31-.76,0-.29-.1-.54-.31-.76l-1.06-1.07c-.21-.22-.46-.33-.76-.32-.3,0-.55.12-.76.34-.21.22-.32.48-.33.78,0,.29.1.54.32.75l1.08,1.05Z" />
        <path d="M5.07,12c0-.29-.11-.55-.32-.76-.21-.21-.46-.32-.76-.32H2c-.29,0-.55.11-.76.32-.21.21-.32.46-.32.76s.11.55.32.76c.21.21.46.32.76.32h2c.29,0,.55-.11.76-.32.21-.21.32-.46.32-.76Z" />
        <path d="M6.35,16.59c-.29,0-.54.11-.76.31l-1.08,1.06c-.22.21-.33.46-.32.76s.12.55.34.76c.22.2.48.31.78.32s.54-.09.75-.31l1.04-1.08c.2-.22.31-.48.32-.77.01-.29-.09-.54-.31-.74-.22-.21-.47-.31-.76-.31Z" />
        <path d="M15,14.27c-1.48,0-2.73-.51-3.74-1.52-1.02-1.02-1.53-2.26-1.53-3.74,0-.53.09-1.02.23-1.5-.53.24-1.01.57-1.46,1.01-.96.96-1.44,2.13-1.44,3.49s.48,2.53,1.44,3.49c.96.96,2.13,1.44,3.49,1.44s2.53-.48,3.49-1.44c.44-.44.77-.93,1.01-1.46-.48.14-.97.23-1.5.23Z" />
        <path d="M18.41,16.9c-.22-.2-.48-.31-.77-.32-.29-.01-.54.09-.74.31-.21.22-.31.47-.31.76,0,.29.11.54.31.76l1.06,1.08c.21.22.46.33.76.32.3,0,.55-.12.76-.34.21-.22.32-.48.33-.78,0-.29-.1-.54-.32-.75l-1.07-1.04Z" />
      </g>
      <g>
        <path
          fill="currentColor"
          d="M16.77,12.23c-1.31,0-2.41-.45-3.3-1.34-.9-.9-1.35-2-1.35-3.3,0-1.12.36-2.12,1.08-2.99.72-.88,1.65-1.4,2.8-1.59.15-.03.28-.03.38,0,.11.03.19.09.25.17.06.08.1.18.1.3,0,.12-.03.25-.09.4-.1.2-.17.41-.23.62s-.08.44-.08.67c0,.79.28,1.47.84,2.03.56.56,1.24.84,2.03.84.23,0,.46-.03.68-.08.22-.05.43-.13.62-.22.14-.06.27-.09.39-.09.12,0,.22.03.29.09.08.06.14.13.17.24.03.1.03.23,0,.38-.17,1.11-.69,2.04-1.56,2.78-.87.74-1.88,1.11-3.02,1.11Z"
        />
      </g>
    </svg>
  );
};

export default IconDarkmode;
